var _g, _path, _path2, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgTappyLogo(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 198,
    height: 198,
    viewBox: "0 0 198 198",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_0_1)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M194 140C194 167.614 171.614 190 144 190H54C26.3858 190 4 167.614 4 140V50C4 22.3858 26.3858 0 54 0H144C171.614 0 194 22.3858 194 50V140Z",
    fill: "white"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M64.672 131V55.736H39.072V39.352H107.552V55.736H81.952V131H64.672Z",
    fill: "#4FBDB7"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M91.671 68.28H107.415V75.832H108.439C109.975 73.1867 112.364 70.9253 115.607 69.048C118.85 67.1707 122.86 66.232 127.639 66.232C131.65 66.232 135.447 67.0853 139.031 68.792C142.7 70.4133 145.9 72.7173 148.631 75.704C151.447 78.6053 153.666 82.104 155.287 86.2C156.908 90.296 157.719 94.776 157.719 99.64C157.719 104.504 156.908 108.984 155.287 113.08C153.666 117.176 151.447 120.717 148.631 123.704C145.9 126.605 142.7 128.909 139.031 130.616C135.447 132.237 131.65 133.048 127.639 133.048C122.86 133.048 118.85 132.109 115.607 130.232C112.364 128.355 109.975 126.093 108.439 123.448H107.415L108.439 132.408V158.648H91.671V68.28ZM124.183 117.56C126.402 117.56 128.492 117.133 130.455 116.28C132.503 115.427 134.295 114.232 135.831 112.696C137.367 111.16 138.604 109.283 139.543 107.064C140.482 104.845 140.951 102.371 140.951 99.64C140.951 96.9093 140.482 94.4347 139.543 92.216C138.604 89.9973 137.367 88.12 135.831 86.584C134.295 85.048 132.503 83.8533 130.455 83C128.492 82.1467 126.402 81.72 124.183 81.72C121.964 81.72 119.831 82.1467 117.783 83C115.82 83.768 114.071 84.92 112.535 86.456C110.999 87.992 109.762 89.8693 108.823 92.088C107.884 94.3067 107.415 96.824 107.415 99.64C107.415 102.456 107.884 104.973 108.823 107.192C109.762 109.411 110.999 111.288 112.535 112.824C114.071 114.36 115.82 115.555 117.783 116.408C119.831 117.176 121.964 117.56 124.183 117.56Z",
    fill: "#33A7E4"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_0_1",
    x: 0,
    y: 0,
    width: 198,
    height: 198,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 4
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_0_1"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_0_1",
    result: "shape"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTappyLogo);
export default __webpack_public_path__ + "static/media/tappy_logo.f625ef658654c6890ad1525489988aca.svg";
export { ForwardRef as ReactComponent };